export default __webpack_public_path__ + "static/m-process-03-4c1d6ad4ea52874818ef3104cbf939d5.svg";